module.exports = __webpack_public_path__ + "img/icon-fun.793d07ae.svg";